import maintLogRepository from '@/repositories/maintLog.repository';

class MaintLogService {
  async runMaintLog (maintLog) {
    const data = await maintLogRepository.runLog(maintLog);
    return data || [];
  }
}
module.exports = new MaintLogService();



// WEBPACK FOOTER //
// ./src/services/maintLog.service.js